import React from 'react'
import { Route, Switch } from 'react-router-dom'

import { routes } from '../routes'
import AccountSelection from './account-selection'
import ClosureSuccess from './closure-success'
import Form from './form'

const Page = () => {
  const isWebView = window.location.pathname.startsWith('/wv/')
  const router = isWebView ? routes.early.wv : routes.early

  return (
    <>
      <Switch>
        <Route
          exact={true}
          path={router.accountSelection}
          component={AccountSelection}
        />
        <Route exact={true} path={router.success} component={ClosureSuccess} />
        <Route exact={true} path={router.index} component={Form} />
      </Switch>
    </>
  )
}

export default Page
